import { render, staticRenderFns } from "./StatsIndex.vue?vue&type=template&id=4cb7b1ad&scoped=true"
import script from "./StatsIndex.vue?vue&type=script&lang=js"
export * from "./StatsIndex.vue?vue&type=script&lang=js"
import style0 from "./StatsIndex.vue?vue&type=style&index=0&id=4cb7b1ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb7b1ad",
  null
  
)

export default component.exports